<template>
  <!-- App.vue -->

  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-card>
        <v-card-title>
          รายการสิทธิประโยชน์
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-btn color="success" dark class="mb-2" @click="editItem()">
            <v-icon left>mdi-plus</v-icon>เพิ่ม
          </v-btn>
        </v-card-title>
        <v-toolbar flat>
          <v-spacer></v-spacer>
        </v-toolbar>

        <!-- delete Privilege dialog -->
        <v-dialog v-model="dialogDelete" max-width="30%">
          <v-card>
            <v-card-title class="headline"
              >ต้องการลบสิทธิ์ประโยชน์นี้ {{ editedItem.name }} ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="closeDelete">ยกเลิก</v-btn>
              <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end delete Privilege -->
        <!-- delete redeem point dialog -->
        <!-- <v-dialog v-model="dialogDeleteTiers" max-width="600px">
          <v-card>
            <v-card-title class="headline"
              >Are you sure you want to delete redeem point ?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                text
                @click="dialogDeleteTiers = !dialogDeleteTiers"
                >Cancel</v-btn
              >
              <v-btn color="success" @click="deleteTiersConfirm">ยืนยัน</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <!-- end delete redeem point  -->
        <div style="text-align: center; padding-left: 30% !important" width="100%">
          <v-alert
            v-if="responseStatus.alertStatus"
            :type="responseStatus.type"
            width="40%"
            style="z-index: 9999; text-align: left"
            dense
            dismissible
          >
            {{ responseStatus.text }}
          </v-alert>
        </div>
        <!-- server-items-length="totalItems" -->
        <v-data-table
          :sort-by.sync="options.sortBy"
          :sort-desc.sync="options.sortDesc"
          :headers="headers"
          :items="privilegesList"
          :options.sync="options"
          :search="search"
          :footer-props="{ 'items-per-page-options': [30, 50, 100, -1] }"
        >
          <template v-slot:item.image="{ item }">
            <v-img
              lazy-src=""
              max-height="90"
              max-width="90"
              :src="api_uri + '/public/' + item.image"
            ></v-img>
          </template>
          <!-- <template v-slot:item.effective_date="{ item }">
            {{ item.effective_date.substring(0, 10) }}
          </template>
          <template v-slot:item.expire_date="{ item }">
            {{ item.expire_date.substring(0, 10) }}
          </template> -->
          <template v-slot:item.status="{ item }">
            <v-switch
              v-model="item.status"
              label=""
              color="success"
              value="Active"
              hide-details
              @click="clickSwitch(item)"
            ></v-switch>
          </template>
          <template v-slot:item.value="{ item }">
            {{ item.value | numFormat("0,000,000.00") }}
          </template>
          <!-- <template v-slot:item.quantity="{ item }">
            {{ item.quantity | numFormat("0,000,000") }}
          </template>
          <template v-slot:item.available="{ item }">
            {{ item.available | numFormat("0,000,000") }}
          </template> -->

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            <v-icon small class="mr-2" @click="viewTier(item)">
              mdi-format-list-checks
            </v-icon>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>
        <!-- add/edit Privilege -->
        <v-navigation-drawer v-model="dialog" temporary right app width="680px">
          <v-card>
            <v-card-title>
              <v-icon @click="close">mdi-close-circle</v-icon>
              <span class="headline form">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.sku"
                      label="SKU *"
                      aria-required="required"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.name"
                      label="ชื่อ *"
                      aria-required="required"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.value"
                      label="มูลค่า *"
                      aria-required="required"
                      type="number"
                    ></v-text-field>
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.point"
                      label="คะแนน *"
                      aria-required="required"
                      type="number"
                    ></v-text-field>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="12" md="12" style="text-align: left">
                    <label>รายละเอียด</label>
                    <vue-editor
                      v-model="editedItem.description"
                      label="รายละเอียด"
                      hint="รายละเอียด"
                      :editorToolbar="customToolbar"
                    ></vue-editor>
                  </v-col> -->

                  <v-col cols="12" sm="12" md="12" style="text-align: left">
                    <label>เงื่อนไข</label>
                    <vue-editor
                      v-model="editedItem.condition"
                      label="เงื่อนไข"
                      hint="เงื่อนไข"
                      :editorToolbar="customToolbar"
                    ></vue-editor>
                  </v-col>

                  <v-col cols="12" sm="12" md="12">
                    <v-img
                      lazy-src=""
                      max-height="290"
                      max-width="290"
                      :src="image"
                    ></v-img>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-file-input
                      v-model="editedItem.image"
                      label="รูป 500px x 500px"
                      show-size
                      append-icon="mdi-camera"
                      accept="image/*"
                      @change="handleImage"
                    ></v-file-input>
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="12">
                    <v-menu
                      ref="start"
                      v-model="start"
                      :close-on-content-click="false"
                      :return-value.sync="editedItem.effective_date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.effective_date"
                          label="วันเริ่มต้น"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required="required"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.effective_date"
                        no-title
                        scrollable
                        :min="nowDate"
                      >
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="start = false"> Cancel </v-btn>
                        <v-btn
                          color="success"
                          @click="$refs.start.save(editedItem.effective_date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      ref="expire"
                      v-model="expire"
                      :close-on-content-click="false"
                      :return-value.sync="editedItem.expire_date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="editedItem.expire_date"
                          label="วันสิ้นสุด"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          required="required"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="editedItem.expire_date"
                        no-title
                        scrollable
                        :min="minExpire"
                      >
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="expire = false"> Cancel </v-btn>
                        <v-btn
                          color="success"
                          @click="$refs.expire.save(editedItem.expire_date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col> -->

                  <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editedItem.quantity"
                      label="จำนวน *"
                      aria-required="required"
                      type="number"
                    ></v-text-field>
                  </v-col> -->

                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="items_status"
                      label="สถานะ *"
                      v-model="editedItem.status"
                      required="required"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="privilege_type"
                      label="ประเภท *"
                      v-model="editedItem.privilegeType"
                      required="required"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    v-if="editedItem.privilegeType == 'Discount'"
                  >
                    <v-select
                      :items="discount_type"
                      label="ประเภทส่วนลด"
                      v-model="editedItem.discountType"
                      required="required"
                    ></v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="shipping"
                      label="จัดส่ง *"
                      v-model="editedItem.shipping"
                    ></v-select>
                  </v-col> -->
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile color="primary" @click="close"> ยกเลิก</v-btn>
              <v-btn tile color="success" @click="save" :disabled="checkRequired">
                ยืนยัน</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>

        <!-- end add/edit Privilege -->
        <!-- redeem point layout -->
        <v-navigation-drawer
          v-model="drawerTiers"
          temporary
          right
          app
          width="100%"
          :stateless="drawerTiers"
        >
          <template>
            <v-toolbar height="50">
              <v-toolbar-title>
                <v-btn icon @click="drawerTiers = !drawerTiers"
                  ><v-icon color="error">mdi-minus</v-icon></v-btn
                >
                Tiers : {{ privilegeName }}
              </v-toolbar-title>
            </v-toolbar>
            <privileges-tiers
              v-bind:privilegeId="privilegeId"
              v-bind:cId="new Date().getMilliseconds().toString()"
              v-if="drawerTiers"
            ></privileges-tiers>
            <!-- <v-simple-table fixed-header height="100%">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Point</th>
                    <th class="text-center">Cash</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-text-field
                        label="Point"
                        hide-details="auto"
                        type="number"
                        v-model="point"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        label="Cash"
                        hide-details="auto"
                        type="number"
                        v-model="cash"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-btn class="success" @click="setTiers"
                        ><v-icon>mdi-plus</v-icon> เพิ่ม
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-for="item in privilegeTier.redeem_point" :key="item.point">
                    <td>{{ item.point | numFormat("0,000,000") }}</td>
                    <td>{{ item.cash | numFormat("0,000,000.00") }}</td>
                    <td>
                      <v-icon left @click="deleteTiers(item)" color="red">
                        mdi-delete
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> -->
          </template>
        </v-navigation-drawer>
        <!-- end redeem point layout-->
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import _ from "underscore";
//import moment from "moment";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";
import privilegesTiers from "../privileges-tiers/privileges-tiers.vue";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
    "privileges-tiers": privilegesTiers,
    "vue-editor": VueEditor,
  },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      // datepicker

      //nowDate: moment(moment()).add(0, "days").toISOString().slice(0, 10),
      //minExpire: moment(moment()).add(2, "days").toISOString().slice(0, 10),
      start: "",
      expire: "",
      //
      privilegeId: "",
      image: "",
      drawer: null,
      drawerTiers: null,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      dialogDeleteTiers: false,
      privilegeName: "",
      editedItem: {
        sku: "",
        name: "",
        value: "",
        // redeem_point: [],
        status: "Active",
        image: "",
        // point: "",
        privilegeType: "Services",
        discountType: "None",
        // shipping: "Yes",
        description: "",
        condition: "",
        //quantity: 0,
      },
      privilegeTier: {},
      //point: "",
      cash: "",
      responseStatus: {
        alertStatus: false,
      },
      show: false,
      defaultItem: {},
      deleteIndex: -1,
      editedIndex: -1,
      edit: false,
      term: null,
      search: "",
      payload: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: ["createdAt"], sortDesc: true },
      Privileges: [],
      tierPrivilege: [],
      //shipping: ["Yes", "No"],
      items_status: ["Active", "Inactive"],
      privilege_type: ["E-Coupon", "Birthday"],
      discount_type: ["Cash", "Percent"],
      headers: [
        {
          value: "privilegeType",
          text: "ประเภท",
        },
        {
          value: "image",
          text: "",
        },
        {
          value: "name",
          text: "ชื่อ",
        },
        {
          value: "value",
          text: "มูลค่า",
        },
        // {
        //   value: "effective_date",
        //   text: "วันเริ่มต้น", // this.$t("tables.headings.effective_date")
        // },
        // {
        //   value: "expire_date",
        //   text: "วันสิ้นสุด", // this.$t("tables.headings.expire_date")
        // },
        {
          value: "status",
          text: "สถานะ", // this.$t("tables.headings.status")
        },
        // {
        //   value: "point",
        //   text: "คะแนน", // this.$t("tables.headings.redeem_point")
        // },
        // {
        //   value: "quantity",
        //   text: "จำนวน", // this.$t("tables.headings.quantity")
        // },
        // {
        //   value: "available",
        //   text: "คงเหลือ", // this.$t("tables.headings.quantity")
        // },
        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
        },
      ],
    };
  },
  created() {
    //this.nowDate.setDate(this.nowDate.getDate() + 7);
    //this.nowDate.toISOString().slice(0,10);
    //console.log(this.nowDate);
    console.log("created");
    /*
    async () => {
    console.log("call vuex");
    this.Privileges = await this.readPrivileges();
    this.totalItems = this.$store.state.totalItems;
    }
    */
  },
  computed: {
    privilegesList() {
      //return this.$store.state.privileges;
      console.log("privilegeList");
      console.log(this.Privileges);
      return this.Privileges.filter((item) => {
        if (this.search.length > 0) {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            item.privilegeType.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        } else {
          return item;
        }
      });
    },

    checkRequired() {
      let required = [
        "sku",
        "name",
        //"value",
        //"point",
        "condition",
        //"effective_date",
        //"expire_date",
        "privilegeType",
        "status",
        //"shipping",
        //"quantity",
      ];
      for (const [key, value] of Object.entries(this.editedItem)) {
        // console.log(key);
        // console.log(value);
        // console.log(required.includes(key));
        // console.log(typeof this.editedItem[key]);
        if (required.includes(key) === true) {
          if (value == "" && typeof this.editedItem[key] !== "object") {
            return true;
          }
        }
      }

      return false;
    },

    PrivilegeFilter() {
      if (this.search.length > 0) {
        return this.Privileges.filter(() => {
          //return item.name.toLowerCase().startsWith(this.search.toLowerCase());
          // this.readPrivileges().then((response) => {
          //   this.Privileges = response.data;
          //   this.totalItems = response.totalItems;
          // });
          this.Privileges.filter((item) => {
            return item.name.toLowerCase().startsWith(this.search.toLowerCase());
          });
        });
      } else {
        return this.Privileges;
      }
    },
    formTitle() {
      return this.editedIndex == -1 ? "เพิ่ม" : "แก้ไข";
    },
  },
  mounted() {
    console.log("mounted");
    this.readPrivileges().then((item) => {
      this.Privileges = item || [];
    });
    this.totalItems = this.$store.state.totalItems;
  },
  methods: {
    clickSwitch(item) {
      console.log(this.$store.state.privileges);
      item.status = item.status == null ? "Inactive" : "Active";
      this.editedIndex = this.$store.state.privileges.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign({}, item);

      //       console.log(this.editedIndex);

      //alert(this.image);

      this.edit = this.editedIndex != -1 ? true : false;
      this.save();
    },
    getColor(status) {
      //console.log(status);
      if (status == "Inactive") return "red";
      else if (status == "Draft") return "blue";
      else return "green";
    },
    click(item, row) {
      console.log(item);
      console.log(row);
    },
    async readPrivileges() {
      ////const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {

        let payload = {
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        let response = await this.$store.dispatch("setPrivilegesList", payload);
        //console.log(this.$store.getters.getAllPrivileges);
        console.log(response);
        if (response != "") {
          console.log(response);
          this.responseStatus = {
            status: "Error",
            code: response.code,
            message: response.message,
          };
          return [];
        } else {
          console.log(" no response ");
          console.log(this.$store.getters.getAllPrivileges);
          return this.$store.getters.getAllPrivileges;
        }
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
        return [];
      }
    },
    resetInput() {
      console.log("input reset");
      //this.editedIndex = null;
      //this.editedItem = null;
      this.point = "";
      this.cash = "";
      this.image = "";
    },
    // redeem
    viewTier(item) {
      console.log(item);
      this.privilegeTier = item;
      this.privilegeName = item.name;
      //this.editedIndex = item._id;
      this.privilegeId = item._id;
      this.drawerTiers = true;
    },
    // async setTiers() {
    //   if (this.editedIndex > -1) {
    //     console.log("update");
    //     //const url = process.env.VUE_APP_LOYALTY_API_URI;
    //     try {
    //       this.payload = {
    //         createdBy: sessionStorage.getItem("email"),
    //         updatedBy: sessionStorage.getItem("email"),
    //         custId: sessionStorage.getItem("custId"),
    //         apiKey: sessionStorage.getItem("apiKey"),

    //         //...this.editedItem,
    //         //image: this.image,
    //         id: this.privilegeTier._id,
    //         point: this.point,
    //         cash: this.cash,
    //       };
    //       console.log(this.payload);
    //       await axios
    //         .put(
    //           this.api_uri + "/v1/privileges/updateTiersPoint",
    //           this.payload, // need to change
    //           {
    //             headers: {
    //               // Overwrite Axios's automatically set Content-Type
    //               "Content-Type": "application/json",
    //               "token": sessionStorage.getItem("token"),
    //             },
    //           }
    //         )
    //         .then((response) => {
    //           //console.log(response.data)
    //           //this.Privilege = response.data;
    //           this.responseStatus = {
    //             status: "Success",
    //             code: 0,
    //             color: "green",
    //             type: "success",
    //             text: "บันทึกสำเร็จ",
    //             alertStatus: true,
    //             data: response.data,
    //           };
    //           //console.log(this.responseStatus)
    //           //this.Privilege = response.data;
    //           this.resetInput();
    //         });

    //       //console.log(this.Privilege);
    //       //console.log("updated");
    //       // if (this.Privilege.nModified == 1) {
    //       //   Object.assign(this.Privileges[this.editedIndex], this.editedItem);
    //       // } else {
    //       //   // do something
    //       // }
    //     } catch (err) {
    //       //console.log(err)
    //       //return err;
    //       return (this.responseStatus = {
    //         status: "Error",
    //         code: 500,
    //         color: "red",
    //         type: "error",
    //         text: err,
    //         alertStatus: true,
    //       });
    //     }
    //   } else {
    //     //const url = process.env.VUE_APP_LOYALTY_API_URI;
    //     try {
    //       this.payload = {
    //         createdBy: sessionStorage.getItem("email"),
    //         updatedBy: sessionStorage.getItem("email"),
    //         custId: sessionStorage.getItem("custId"),
    //         apiKey: sessionStorage.getItem("apiKey"),

    //         id: this.privilegeTier._id,
    //         redeem_point: [
    //           ...this.privilegeTier.redeem_point,
    //           {
    //             point: this.point,
    //             cash: this.cash,
    //           },
    //         ],
    //       };
    //       await axios
    //         .post(
    //           this.api_uri + "/v1/privileges/updateTiersPoint",
    //           this.payload, // need to change
    //           {
    //             headers: {
    //               // Overwrite Axios's automatically set Content-Type
    //               "Content-Type": "application/json",
    //               "token": sessionStorage.getItem("token"),
    //             },
    //           }
    //         )
    //         .then((response) => {
    //           this.responseStatus = {
    //             status: "Success",
    //             code: 0,
    //             color: "green",
    //             type: "success",
    //             text: "บันทึกสำเร็จ",
    //             alertStatus: true,
    //             data: response.data,
    //           };
    //           //this.totalItems++;
    //           // Object.assign(this.privilegeTier.redeem_point , {
    //           //   point: this.point,
    //           //   cash: this.cash,
    //           // });
    //           this.privilegeTier.redeem_point = [
    //             ...this.privilegeTier.redeem_point,
    //             {
    //               point: this.point,
    //               cash: this.cash,
    //             },
    //           ];
    //           //console.log(this.privilegeTier.redeem_point);
    //           this.resetInput();
    //         })
    //         .catch((error) => {
    //           console.log(error);
    //         });
    //     } catch (err) {
    //       return (this.responseStatus = {
    //         status: "Error",
    //         code: 500,
    //         color: "red",
    //         type: "error",
    //         text: err,
    //         alertStatus: true,
    //       });
    //     }
    //   }
    //   // if(this.responseStatus.code == 0){
    //   //   this.totalItems++;
    //   // }
    //   //console.log("saved");
    //   console.log(this.privilegeTier.redeem_point);
    //   //this.close();
    // },
    // deleteTiers(item) {
    //   console.log(item);
    //   this.deleteIndex = this.privilegeTier.redeem_point.indexOf(item);

    //   this.dialogDeleteTiers = true;
    // },
    // async deleteTiersConfirm() {
    //   console.log("deleteTiersConfirm");
    //   this.dialogDeleteTiers = !this.dialogDeleteTiers;

    //   //const url = process.env.VUE_APP_LOYALTY_API_URI;
    //   try {
    //     this.payload = {
    //       createdBy: sessionStorage.getItem("email"),
    //       updatedBy: sessionStorage.getItem("email"),
    //       custId: sessionStorage.getItem("custId"),

    //       // point: this.privilegeTier.redeem_point[this.deleteIndex].point,
    //       // cash: this.privilegeTier.redeem_point[this.deleteIndex].cash,
    //     };

    //     const response = await axios.post(
    //       this.api_uri + "/v1/privileges/deleteTiersPoint/" + this.privilegeTier._id,
    //       this.payload
    //     );
    //     //console.log(response);

    //     if (response.data.n == response.data.nModified > 0) {
    //       this.responseStatus = {
    //         status: "Success",
    //         code: 0,
    //         color: "green",
    //         type: "success",
    //         text: "บันทึกสำเร็จ",
    //         alertStatus: true,
    //       };
    //       this.privilegeTier.redeem_point.splice(this.deleteIndex, 1);
    //       this.resetInput();
    //     } else {
    //       this.responseStatus = {
    //         status: "Error",
    //         code: 8001,
    //         color: "red",
    //         type: "error",
    //         text: "พบปัญหา กรุณาลองใหม่",
    //         alertStatus: true,
    //       };
    //     }
    //   } catch (err) {
    //     return (this.responseStatus = {
    //       status: "Error",
    //       code: 500,
    //       color: "red",
    //       type: "error",
    //       text: err,
    //       alertStatus: true,
    //     });
    //   }

    //   //this.closeDeleteR();
    // },
    // end redeem
    editItem(item) {
      //console.log(item);
      //console.log(this.$store.state.privileges);
      this.editedIndex = this.$store.state.privileges.indexOf(item);
      //this.editedItem = {};
      this.resetEditedItem();
      if (this.editedIndex > -1) {
        this.editedItem = Object.assign({}, item);
      }

      //console.log(this.editedIndex);

      if (_.size(this.editedItem) > 0 && this.editedIndex > -1) {
        //this.editedItem.effective_date = this.editedItem.effective_date.substring(0, 10);
        //}
        //if (this.editedItem.expire_date != "") {
        //this.editedItem.expire_date = this.editedItem.expire_date.substring(0, 10);

        if (this.editedItem.image != "") {
          this.image = this.api_uri + "/public/" + this.editedItem.image;
        } else {
          this.image = "";
        }
      }
      //alert(this.image);

      this.edit = this.editedIndex != -1 ? true : false;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.Privileges.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      console.log("deleteConfirm");
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        const response = await axios.delete(
          this.api_uri + "/v1/privileges/delete/" + this.editedItem._id
        );
        console.log(response);

        if (response.data.n == response.data.deletedCount > 0) {
          this.responseStatus = {
            status: "Success",
            code: 0,
            color: "green",
            type: "success",
            text: "บันทึกสำเร็จ",
            alertStatus: true,
          };
          this.Privileges.splice(this.editedIndex, 1);
          //this.readPrivileges()
          this.totalItems--;
        } else {
          this.responseStatus = {
            status: "Error",
            code: 8001,
            color: "red",
            type: "error",
            text: "พบปัญหา กรุณาลองใหม่",
            alertStatus: true,
          };
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }

      this.closeDelete();
    },
    resetEditedItem() {
      this.editedItem = {
        sku: "",
        name: "",
        value: "",
        // redeem_point: [],
        status: "Active",
        image: "",
        // point: "",
        privilegeType: "Services",
        discountType: "None",
        // shipping: "Yes",
        description: "",
        condition: "",
      };
    },
    close() {
      this.dialog = false;
      this.edit = false;
      console.log("close");
      this.$nextTick(() => {
        //console.log("nexttick");
        this.editedItem = Object.assign({}, {});
        this.image = "";
        //if (this.editedItem.image == "" || this.editedItem.image.length == 0 ) this.image = "";
        //this.editedIndex = -1;
        console.log(this.editedIndex);
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        //this.image = null;
        this.image = "";
        //this.editedIndex = -1;
      });
    },
    // timeout close overlay
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    async save() {
      if (this.editedIndex > -1) {
        console.log("update");
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          let payload = {
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),
            ...this.editedItem,
            image: this.image,
            id: this.editedItem._id,
            index: this.editedIndex,
          };
          // //console.log(payload);
          // let response = await this.$store.dispatch("updatePrivileges", payload);
          // //this.$set(this.$store.state.privileges, this.editedIndex,payload);)
          // //console.log(this.$store.state.privileges[this.editedIndex]);
          // if (response) {
          //   this.Privileges[this.editedIndex] = this.$store.state.privileges[this.editedIndex];
          //   ///console.log(this.editedIndex);
          //   //Object.assign({}, this.Privileges[this.editedIndex], this.$store.state.privileges[this.editedIndex]);
          //   //console.log(this.Privileges[this.editedIndex]);
          //   //this.totalItems = this.$store.state.totalItems;
          //   //await this.$nextTick();
          //   console.log("updated privilege");
          //   console.log(this.Privileges);
          //   this.responseStatus = {
          //     status: "Success",
          //     code: 0,
          //     color: "green",
          //     type: "success",
          //     text: "Updated",
          //     alertStatus: true,
          //     //data: response.data,
          //   };
          // } else {
          //   this.responseStatus = {
          //     status: "Error",
          //     code: 500,
          //     color: "red",
          //     type: "error",
          //     text: "Update failed",
          //     alertStatus: true,
          //   };
          // }

          await axios
            .put(
              this.api_uri + "/v1/privileges/update",
              payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              //console.log(response.data)
              //this.Privilege = response.data;
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                //data: response.data.data,
              };
              Object.assign(this.Privileges[this.editedIndex], response.data.data);
              //console.log(this.responseStatus)
              //this.Privileges = response.data;
            });

          //console.log(this.Privilege);
          //console.log("updated");
          // if (response.data.nModified == 1) {
          // } else {
          //   // do something
          // }

          this.dialog = false;
        } catch (err) {
          //console.log(err)
          //return err;
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      } else {
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          let payload = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),
            ...this.editedItem,
            image: this.image,
          };

          await axios
            .post(
              this.api_uri + "/v1/privileges/create",
              payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              console.log(response);
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };

              console.log(this.responseStatus);
              this.Privileges.push(response.data);
              this.totalItems++;
            })
            .catch((error) => {
              console.log(error);
            });

          // let response = await this.$store.dispatch("addPrivileges", payload);
          // console.log(response);
          // if (response) {
          //   this.totalItems = this.$store.state.totalItems;
          //   //await this.$nextTick();
          //   //if (response != "") {
          //   this.responseStatus = {
          //     status: "Success",
          //     code: 0,
          //     color: "green",
          //     type: "success",
          //     text: "Privilege added",
          //     alertStatus: true,
          //     //data: response.data,
          //   };
          // } else {
          //   this.responseStatus = {
          //     status: "Error",
          //     code: 500,
          //     color: "red",
          //     type: "error",
          //     text: "Error add failed",
          //     alertStatus: true,
          //   };
          // }
          this.dialog = false;
        } catch (err) {
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      }
      // if(this.responseStatus.code == 0){
      //   this.totalItems++;
      // }
      console.log("saved");
      console.log(this.totalItems);
      //this.close();
    },
    handleImage(e) {
      //console.log(e);
      console.log(typeof e);
      //console.log(e.target.file[0])
      //const uploadImage = e.target.files[0];
      //console.log(this.editedItem.image);
      if (typeof e != "undefined") {
        console.log(e);
        this.createBase64Image();
      } else {
        this.image = "";
      }
    },
    createBase64Image() {
      const reader = new FileReader();
      reader.readAsDataURL(this.editedItem.image);
      reader.onload = (e) => {
        this.image = e.target.result;
        //console.log(e.target.result);
      };
      //console.log(reader.readAsDataURL(this.image));
    },
  },

  watch: {
    search: {
      handler(val) {
        console.log("search");
        console.log(val);
        /*
        this.readPrivileges().then((response) => {
          this.Privileges = response.data.filter((item) => {
            return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
          });
          this.totalItems = response.totalItems;
        });
        */
      },
    },
    dialog(val) {
      console.log(val);
      if (this.editedIndex == -1 && this.editedItem.image == "") {
        this.image = "";
      }
      val || this.close();
    },
    dialogDelete(val) {
      console.log(val);
      val || this.closeDelete();
    },
    totalItems: {
      handler(newVal, oldVal) {
        console.log(newVal + " " + oldVal);
        // this.Privileges = this.$store.state.privileges;
        // console.log(this.Privileges);
      },
    },
    Privileges: {
      handler() {},
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
    editedItem: {
      handler() {
        console.log("editedItem");
        console.log(this.editedItem);
        console.log(_.size(this.editedItem));
        // if (_.size(this.editedItem) > 0) {
        //   this.editedItem.effective_date = this.editedItem.effective_date.substring(
        //     0,
        //     10
        //   );
        //   //}
        //   //if (this.editedItem.expire_date != "") {
        //   this.editedItem.expire_date = this.editedItem.expire_date.substring(0, 10);

        //   if (this.editedItem.image != "") {
        //     this.image = this.editedItem.image;
        //   } else {
        //     this.image = "";
        //   }
        // }
      },
    },
  },
};
</script>
